export enum TypesButton {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  LIGHT = 'light',
  TEXT = 'text',
  ICON = 'icon',
  GRAY = 'gray',
  DELETE = 'delete',
}
